import { Component } from 'react';
import { NSARouterMakerResult } from 'namirasoft-account-react';
import { ContainerRegistryRouterProps } from '../ContainerRegistryRouterProps';
import { ContainerRegistryEntities } from '../ContainerRegistryEntities';
import { ContainerRegistryLayout } from '../ContainerRegistryLayout';

export interface ContainerRegistryViewPageProps extends NSARouterMakerResult, ContainerRegistryRouterProps { }

class ContainerRegistryViewPage extends Component<ContainerRegistryViewPageProps>
{
    override render()
    {
        return (
            <ContainerRegistryLayout
                {...this.props}
                pages={{
                    entity: ContainerRegistryEntities.container_registry(this.props),
                    view: {},
                }}
            >
                <></>
            </ContainerRegistryLayout >
        )
    }
}

export default ContainerRegistryViewPage;